import React from 'react';
import { render } from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import configureStore, { history } from './store/configureStore';
import Root from './components/Root';
import * as serviceWorker from './serviceWorker';
import { loadState, saveState } from "./store/localStorage";

import {
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import br from "date-fns/locale/pt-BR";

// import Test from './test';

const persistedState = loadState();
const store = configureStore(persistedState);
store.subscribe(() => {
  saveState(store.getState());
});


render(
  <>
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={br}>
      <AppContainer>

        <Root store={store} history={history} />

      </AppContainer>
    </MuiPickersUtilsProvider>
    {/* <Test /> */}
  </>,
  document.getElementById('root')
);

if (module.hot) {
  module.hot.accept('./components/Root', () => {
    const NewRoot = require('./components/Root').default;
    render(
      <>
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
          <AppContainer>
            <NewRoot store={store} history={history} />
          </AppContainer>
        </MuiPickersUtilsProvider>
      </>,
      document.getElementById('root')
    );
  });
}


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
